<template>
  <div class="client-target-distribution-container">
    <mf-card-container
      title="Público alvo"
      description="Defina o público alvo de sua campanha. Você pode distribuir diferentes pesos para os grupos de consumidores, dessa forma você consegue direcionar a campanha para os grupos mais desejados. Você também pode adicionar um segmento e restringir a campanha apenas para esse público."
    >
      <budget-range-slider :hundred-percent-error.sync="hundredPercentError" :has-hundred-percent-error.sync="hasHundredPercentError" />
      <hr />
      <budget-segmentation />
    </mf-card-container>
  </div>
</template>

<script>
import BudgetRangeSlider from './BudgetRangeSlider.vue'
import BudgetSegmentation from './BudgetSegmentation.vue'
export default {
  name: 'ClientTargetDistribution',
  components: {
    BudgetRangeSlider,
    BudgetSegmentation,
  },
  props: {
    myProp: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    hundredPercentError: false,
    hasHundredPercentError: false,
  }),
  computed: {},
  watch: {},
  mounted() {},
  methods: {
    validateStepThreeFormData() {
      if (this.hundredPercentError) {
        this.hasHundredPercentError = true
        this.$nextTick(() => this.$vuetify.goTo(document.querySelector('.error--text'), { offset: 200, duration: 300 }))
        return false
      }
      return true
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .card-container-description {
  max-width: 1000px;
}

hr {
  border-top: 1px solid $cinza-l70;
  margin: 24px 0;
}
</style>
